module.exports = __webpack_public_path__ + "img/tagline.934b287b.png";